import {
	FormItem,
	ReorderableList,
	Select,
	SelectOption,
	TextInput,
	ValidationError
} from "client/Components";
import { ZenyaDocResourceKind } from "client/Api/Workspace/LiveInformation/ZenyaDoc/zenyaDocLiveInformation";
import { IInputAttachable, IValueInputAttachable } from "client/Forms/attachable";
import { useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { UpdateZenyaDocTabModel } from "client/Api/Workspace/workspace";


const tabKindOptions: readonly SelectOption<ZenyaDocResourceKind>[] = [
	{ text: localize("_BrowseDocuments"), value: ZenyaDocResourceKind.BrowseDocuments },
	{ text: localize("_Favorites"), value: ZenyaDocResourceKind.Favorites }
];

type EditZenyaDocTabItemProps = {
	attachable: IValueInputAttachable<UpdateZenyaDocTabModel>;
	onRemoveTab: () => void;
};

export const EditZenyaDocTabItem = (props: EditZenyaDocTabItemProps) => {
	const { attachable, onRemoveTab } = props;
	const nameAttachable: IInputAttachable<string> = attachable.for("name");

	const resourceKindChangeHandler = useCallback(
		(newValue: ZenyaDocResourceKind | null): void => {
			const onChange: (newValue: string) => void = nameAttachable.attachToTextInput()
				.onChange;

			if (
				newValue !== attachable.value
					.resourceKind
			) {
				const nameValue: string = tabKindOptions.find(
					(option) => option.value === newValue
				)
					?.text ?? "";

				onChange(nameValue);
			}
		},
		[
			nameAttachable,
			attachable.value
				.resourceKind
		]
	);

	return (
		<ReorderableList.PanelItem
			{...attachable.attachToReorderableListPanelItem(true)}
			header={
				<Select
					{...attachable
						.for("resourceKind")
						.attachToSelect()
						.withOnChange(resourceKindChangeHandler)}
					options={tabKindOptions}
					placeholder={localize("_PleaseSelect")}
					menuTitle={localize("_Source")}
				/>
			}
			onRemove={onRemoveTab}
		>
			<ValidationError
				{...attachable.for("resourceKind")
					.attachToValidationError()}
			/>
			<FormItem
				label={localize("_TabName")}
			>
				<TextInput
					{...nameAttachable.attachToTextInput()}
				/>
				<ValidationError
					{...nameAttachable.attachToValidationError()}
				/>
			</FormItem>
		</ReorderableList.PanelItem>
	);
};

EditZenyaDocTabItem.displayName = "EditYammerTabItem";